import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Topbar from "../../Layouts/Topbar";
import Header from "../../Layouts/Header";
import InnerBanner from "../../Layouts/InnerBanner";
import Footer from "../../Layouts/Footer";
import { API } from "../../constants";
import useCompanyStore from "../../hooks/useCompanyStore";

const ContactUs = () => {
  const { companyId } = useCompanyStore();
  const [settings, setSettings] = useState({
    location: "",
    instagramUrl: "",
    facebookUrl: "",
    email: "",
    contactNo: "",
  });

  const fetchSettings = async () => {
    try {
      const response = await fetch(API.LIST_SETTINGS + "/" + companyId, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.message || "Something went wrong");
      }

      if (result?.data?.length > 0) {
        setSettings({
          location: result.data[0].location || "",
          instagramUrl: result.data[0].instagramUrl || "",
          facebookUrl: result.data[0].facebookUrl || "",
          email: result.data[0].email || "",
          contactNo: result.data[0].contactNo || "",
        });
      }
    } catch (error) {
      console.error("Fetch Settings Error:", error);
    }
  };
 useEffect(() => {
  if (!companyId) return;

  fetchSettings();
}, [companyId]);

  const mapLocation = settings.location || "London, UK";

  return (
    <>
      <Topbar />
      <Header />
      <InnerBanner />

      <section className="py-5 bg-light">
        <Container>
          <Row>
            <Col md={12}>
              <div className="mb-4">
                <iframe
                  src={`https://www.google.com/maps?q=${encodeURIComponent(
                    mapLocation
                  )}&output=embed`}
                  style={{ border: 0, width: "100%", height: "400px" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Map"
                ></iframe>
              </div>
            </Col>
          </Row>

          <Row className="text-center g-4">
            <Col md={4}>
              <div className="p-3 bg-white shadow rounded h-100">
                <i className="fa-solid fa-share-nodes fa-2x mb-2"></i>
                <h5>SOCIAL LINKS</h5>

                {settings.facebookUrl && (
                  <p className="mb-1">
                    <i className="fa-brands fa-facebook-f"></i>{" "}
                    <a
                      href={settings.facebookUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                  </p>
                )}

                {settings.instagramUrl && (
                  <p className="mb-0">
                    <i className="fa-brands fa-instagram"></i>{" "}
                    <a
                      href={settings.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Instagram
                    </a>
                  </p>
                )}

                {!settings.facebookUrl && !settings.instagramUrl && (
                  <p className="mb-0">No social links available</p>
                )}
              </div>
            </Col>

            <Col md={4}>
              <div className="p-3 bg-white shadow rounded h-100">
                <i className="fa-solid fa-location-dot fa-2x mb-2"></i>
                <h5>ADDRESS</h5>
                <p>{settings.location || "London, UK"}</p>
              </div>
            </Col>

            <Col md={4}>
              <div className="p-3 bg-white shadow rounded h-100">
                <i className="fa fa-envelope fa-2x mb-2"></i>
                <h5>EMAIL</h5>

                {settings.email ? (
                  <p className="mb-1">
                    <a href={`mailto:${settings.email}`}>{settings.email}</a>
                  </p>
                ) : (
                  <p className="mb-1">
                    <a href="mailto:support@yourdomain.com">
                      support@yourdomain.com
                    </a>
                  </p>
                )}
              </div>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col md={{ span: 8, offset: 2 }} className="text-center">
              <h3 className="text-center">
                If You Got Any Questions,
                <br />
                Please Do Not Hesitate to Send us a Message.
              </h3>

              <Form className="mt-4 p-4 bg-white shadow rounded contact-form-area">
                <Form.Group className="mb-3" controlId="name">
                  <Form.Control type="text" placeholder="Your Name" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="email">
                  <Form.Control type="email" placeholder="Your Email" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="subject">
                  <Form.Control type="text" placeholder="Subject" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="message">
                  <Form.Control as="textarea" placeholder="Message" />
                </Form.Group>

                <Button variant="primary" type="submit">
                  SEND MESSAGE
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default ContactUs;